<div class="form-group {{inline === true ? 'row inline-from-row' : ''}}">
  <label [ngClass]="(inline === true ? 'col-3' : '')">{{label}}</label>
  <div [ngClass]="(inline === true ? 'col-9' : '')">
    <input type="{{inputType}}" class="form-control form-control-sm {{additionalClass}}" [(ngModel)]="model"
      (change)="change()" placeholder="{{placeHolder}}" [disabled]="disabled" />
  </div>
</div>
